<template>
	<div class="tl-group"
	     aria-expanded="false"
	     :aria-controls="'collapseExample' + containerId"
	>
		<div class="tl-group-wrapper">
			<div class="tl-group-txt">
				<div class="tl-group-icon"></div>
				<div class="f-16 f-bold tl-group-title">{{ header }}</div>
			</div>
			<!-- Timeline Group Items -->
			<SOTransaksiStatusTahapanLayanan
				v-for="(d, i) in detail.slice(0, 1)"
				:key="i"
				:title="titleFiller(d)"
				:sub-title="subtitleFiller(d)"
				:date="d.waktu"
				:date-raw="d.waktu_raw"
				:note="d.catatan"
				:images="d.foto_tahapan === null ? [] : d.foto_tahapan"
			/>

			<div class="collapse" :id="'collapseExample' + containerId" v-if="detail.length > 1">
				<SOTransaksiStatusTahapanLayanan
					v-for="(d, i) in detail.slice(1, detail.length)"
					:key="i"
					:title="titleFiller(d)"
					:sub-title="subtitleFiller(d)"
					:date="d.waktu"
					:date-raw="d.waktu_raw"
					:note="d.catatan"
					:images="d.foto_tahapan === null ? [] : d.foto_tahapan"
				/>
			</div>

			<!-- At the end of timeline group items -->
			<div class="tl-expand" v-if="detail.length > 1">
				<div class="tl-expand-icon"></div>
				<div
					class="tl-expand-txt f-14 f-semi f-c-midgrey"
					data-toggle="collapse"
					:data-target="'#collapseExample' + containerId"
				>
					<div class="tl-expand-open">Klik untuk lihat tahapan lainnya</div>
					<div class="tl-expand-close">Sembunyikan tahapan</div>
				</div>
			</div>

		</div>

		<!-- Timeline group tail -->
		<div class="tl-group-tail">
			<div class="tlx-line"></div>
		</div>

	</div>
</template>

<script>
import SOTransaksiStatusTahapanLayanan
	from "@/so-components/modules/transaksi/reguler/status/SOTransaksiStatusTahapanLayanan";

export default {
	name: "SOTransaksiStatusTahapanLayananContainer",
	components: {
		SOTransaksiStatusTahapanLayanan,
	},
	props: {
		header: String,
		detail: Array,
		endOfLine: Boolean,
		containerId: Number,
	},
	methods: {
		titleFiller(d) {
			let title = ""
			switch (d.nama_tahapan) {
				case "Diambil":
					title = 'Pengambilan Barang oleh Konsumen'
					break;
				case "Finishing":
					title = 'Selesaikan Layanan'
					break;
				default:
					title = d.nama_tahapan
					break;
			}
			return title;
		},
		subtitleFiller(d) {
			let subtitle = ""
			switch (d.nama_tahapan) {
				case "Diambil":
					subtitle = "Diserahkan oleh " + d.nama_karyawan
					break;
				case "Finishing":
					subtitle = "Diselesaikan oleh " + d.nama_karyawan
					break;
				default:
					subtitle = d.nama_karyawan === "" ? "" : "Oleh " + d.nama_karyawan
					break;
			}
			return subtitle
		}
	}
}
</script>